const getHeaders = () => {
  let userData = JSON.parse(localStorage.getItem('user'));
  let authToken = userData?.result.data.token;
  return {
    Authorization: 'Bearer ' + authToken,
  };
};

export default getHeaders;
